@let items = filter.getFields() | async;

<div class="checked-filter-tags">

  @for (item of items; track item) {
    @if (item.key == 'hasStock') {
      @if (showHasStock) {
        <span size="small" appearance="outline">
          <nb-checkbox i18n="@@InStock" [checked]="hasStock" (checkedChange)="onChangeRange($event)">В наличии</nb-checkbox>
        </span>
      }
    }
  }

  @if (keyword) {
    <button (click)="delete('keyword')" i18n-nbTooltip="@@RemoveFromFilter" nbButton nbTooltip="Убрать из фильтра" size="small" appearance="outline">
      {{ keyword }}
      <tui-icon icon="x"/>
    </button>
  }

  @for (item of items; track item) {
    @if (!filter.isEmptyField(item) && item.key != 'hasStock') {
      @if (item.type == 'checkbox') {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small" appearance="outline">
          {{ item.templateOptions.label }}
          <tui-icon icon="x"/>
        </button>
      } @else if (item.type == 'select-multi-filter-property') {
        @for (itemMulti of item.defaultValue; track itemMulti) {
          <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key, itemMulti)" nbButton size="small" appearance="outline">
            {{ getDisplayValue(item, itemMulti) }}
            <tui-icon icon="x"/>
          </button>
        }
      } @else if (item.type == 'date-range-picker') {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small" appearance="outline">
          {{ item.templateOptions.label }} {{ item.defaultValue.from }}-{{ item.defaultValue.to }}
          <tui-icon icon="x"/>
        </button>
      } @else {
        <button i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="Убрать из фильтра" (click)="delete(item.key)" nbButton size="small" appearance="outline">
          {{ getDisplayValue(item) }}
          <tui-icon icon="x"/>
        </button>
      }
    }
  }

  @if (keyword != '' || (filter.getCtnActiveFeatures() | async)) {
    <button (click)="reset()" i18n="@@CancelAllFilters" nbButton size="small" appearance="outline">
      Сбросить фильтры
    </button>
  }

</div>
